import React,{ useState } from "react";
import DownloadIcon from "./../../../assets/icons/download-icon.svg";
import RemoveIcon from "./../../../assets/icons/remove-icon.svg";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import Tooltip from "@mui/material/Tooltip";
import { StyledAttachment, StyledCircularProgress, CircularSize } from "./attachmentComponent.style";
import CircularProgress from '@mui/material/CircularProgress';

export interface IAttachmentsProps {
  attachments: [];
  handleDownloadClick: (item: any) => {};
  handleDeleteFileClick: (item: any) => {};
  isShowDownload: boolean;
  isShowDelete: boolean;
  fullWidth: boolean;
  isBold: boolean;
  activeTab?: string;
  isHomePage?: boolean;
}

const Attachments = (props: IAttachmentsProps) => {
  const {
    attachments,
    fullWidth = false,
    isShowDownload,
    isShowDelete,
    isBold,
    handleDeleteFileClick,
    handleDownloadClick,
    activeTab,
    isHomePage,
  } = props;

  const isAttachmentNotEmpty = attachments.length > 0;

  const styleWrapper = {
    fullWidth: fullWidth,
    isBold: isBold,
  };

  return isAttachmentNotEmpty ? (
    <StyledAttachment styleWrapper={styleWrapper}>
      <ul className="attachments">
        {attachments.map((item: any, index: any) => {
          let showDelete;
          if((item?.isApproval || item?.isRequest) && activeTab === 'approvals') {
            showDelete = isShowDelete && item?.isApproval? true : false;
          } else if ((item?.isApproval || item?.isRequest) && (activeTab === 'requests' || !!isHomePage)) {
            showDelete = isShowDelete && item?.isRequest? true : false;
          } else {
            showDelete = isShowDelete;
          };
          return (
            <SingleAttachment 
              index={index}
              item={item}
              isShowDownload={isShowDownload}
              isShowDelete={showDelete}
              handleDeleteFileClick={handleDeleteFileClick}
              handleDownloadClick={handleDownloadClick}
            />
          );
        })}
      </ul>
    </StyledAttachment>
  ) : (
    <></>
  );
};

export interface ISingleAttachmentProps {
  index: any;
  item: {fileName: string;};
  handleDownloadClick: (item: any) => {};
  handleDeleteFileClick: (item: any) => {};
  isShowDownload: boolean;
  isShowDelete: boolean;
}

const SingleAttachment = (props: ISingleAttachmentProps) => {
  const {
    index,
    item,
    isShowDownload,
    isShowDelete,
    handleDeleteFileClick,
    handleDownloadClick,
  } = props;
  const fileName = item.fileName;
  const startFileName = fileName.slice(0, fileName.length - 6);
  const endFileName = fileName.slice(fileName.length - 6);

  const [isLoading, setIsLoading] = useState(false);

  return (
      <li key={index}>
        {isShowDelete? (
          <button onClick={() => handleDeleteFileClick(item)} id="btn-attachmentcomponent-delete">
            <img
              className="remove-icon"
              src={RemoveIcon}
              alt="remove-icon"
              title="Remove Icon"
              id="img-attachmentcomponent-delete"
            />
          </button>
        ): (<div className="icon-delete"></div>)}
        <DescriptionOutlinedIcon />
        <Tooltip title={fileName} arrow placement="top-start">
          <div className="file-name">
            <div className="start" id="lbl-attachmentcomponent-start_file_name">{startFileName}</div>
            <div className="end" id="lbl-attachmentcomponent-end_file_name">{endFileName}</div>
          </div>
        </Tooltip>
        {isShowDownload && (
          <button onClick={async () => {
              setIsLoading(true);
              await handleDownloadClick(item);
              setIsLoading(false);
            }}
            id="btn-attachmentcomponent-download">
            <img src={DownloadIcon} alt="download-icon" title="Download Icon" id="img-attachmentcomponent-download"/>
          </button>
        )}
        {isLoading && (
          <StyledCircularProgress className="loading-attachment">
            <CircularProgress style={CircularSize} id="img-attachmentcomponent-loading"/>
          </StyledCircularProgress>
        )}
      </li>
  );
}

export default Attachments;
